import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function TreeCatchmentView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Name",
      children: prodd?.tmcName ?? "N/A",
    },
    {
      key: "5",
      label: "Status",
      children: prodd?.tmcStatus ?? "N/A",
    },
    {
      key: "2",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "4",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "55",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    },
    {
      key: "6",
      label: "Latitudes",
      children: prodd?.tmcLat ?? "N/A",
    },
    {
      key: "7",
      label: "Longitudes",
      children: prodd?.tmcLong ?? "N/A",
    },
  
    {
      key: "9",
      label: "Size (Acres)",
      children: prodd?.tmcSize ?? "N/A",
    },
    {
      key: "10",
      label: "Slope of The Ground",
      children: prodd?.typoTypography ?? "N/A",
    },
    
    {
      key: "12",
      label: "Types of Trees Grown",
      children: prodd?.tmcTreeTypeGrown ?? "N/A",
    },
    {
      key: "13",
      label: "Method of Water Harvesting",
      children: prodd?.whType ?? "N/A",
    },
    {
      key: "14",
      label: "Type of Fence Used",
      children: prodd?.tmcFenceType ?? "N/A",
    },
    {
      key: "15",
      label: "Type of Vegetation",
      children: prodd?.tmcVegetationTypeGrown ?? "N/A",
    },
    {
      key: "16",
      label: "Type of Animals Being Grazed",
      children: prodd?.tmcAnimalGrazedType ?? "N/A",
    },
    {
      key: "17",
      label: "Source of Water",
      children: prodd?.tmcWaterSourceDirection ?? "N/A",
    },
    {
      key: "18",
      label: "Area of The Reserve",
      children: prodd?.tmcReserveArea ?? "N/A",
    },
    {
      key: "19",
      label: "Type of Reserve",
      children: prodd?.rtType ?? "N/A",
    },
    {
      key: "20",
      label: "Pathways",
      children: prodd?.tmcPathways ?? "N/A",
    },

    {
      key: "21",
      label: "Topography",
      children: prodd?.tmcTypography ?? "N/A",
    },
    
  ];
    
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Triangular Micro Catchment For Trees</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Details"
          column={2}
          colon={false}
          items={items1}
          layout="vertical"
        />
       
      </div>
    </Drawer>
  );
}

export default TreeCatchmentView;
